// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__p5s_s","icon":"SortAdornment_icon__1oxMK","up":"SortAdornment_up__ORtF5","down":"SortAdornment_down__30IMg","active":"SortAdornment_active__2h0wA"};